import React from "react";
import classNames from "classnames";
import "./index.scss";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemPassword = ({ column, value, onPropChange }) => (
  <div
    key={`propItem-${column.accessor}`}
    className={classNames("sectionItemPassword")}
  >
    <ColumnTitleWithIcon column={column} item={value}/>
    <div className={classNames("inputItem", { required: column.isRequired })}>
      <input
        value={value || ""}
        type="password"
        readOnly={column.isReadonly}
        onChange={e =>
          onPropChange({ [column.accessor]: e.currentTarget.value })
        }
      />
    </div>
  </div>
);

export default SectionItemPassword;
